import BarCodeDetail from "./BarCodeDetail";
export default BarCodeDetail;
